/* istanbul ignore file */
import { Component, input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NgClass } from '@angular/common';

export type ModalSize = 'sm' | 'md' | 'md plus' | 'lg';

@Component({
    selector: 'pgh-modal-window',
    templateUrl: './modal-window.component.html',
    styleUrls: ['./modal-window.component.scss'],
    imports: [NgClass]
})
export class ModalWindowComponent {
  readonly size = input<ModalSize>('md');
  readonly closeButton = input(true);

  constructor(public dialogRef: MatDialogRef<ModalWindowComponent>) {
    // this property was not allowing to close the modal with esc key
    // dialogRef.disableClose = true;
  }
}
